import type { Campaign, CampaignEligibility, CampaignsListResponse } from '../../api/models/bff/Campaign';

export function createMockCampaignEligibility(overrides?: Partial<CampaignEligibility>): CampaignEligibility {
  return {
    type: 'PUBLIC',
    requiredParameters: [],
    ...overrides,
  };
}

export function createMockCampaign(overrides?: Partial<Campaign>): Campaign {
  return {
    code: 'SUMMER-SALE-2026',
    displayStatus: 'ACTIVE',
    boundaryType: 'TIME_BOUNDED',
    startDate: '2026-06-01T00:00:00Z',
    endDate: '2026-09-01T00:00:00Z',
    eligibility: [createMockCampaignEligibility()],
    ...overrides,
  };
}

export function createMockCampaignsListResponse(campaigns?: Campaign[]): CampaignsListResponse {
  return campaigns ?? [createMockCampaign()];
}
